import { Component, Input, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NetworkEventRecordDTO } from 'src/app/core/models/system/webbing/network-event-record.dto';

@Component({
  selector: 'app-sim-network-event-embedded',
  templateUrl: './sim-network-event.component.html',
  styleUrls: ['./sim-network-event.component.scss']
})

export class SimNetworkEventEmbeddedComponent implements OnInit {

  @Input() locationLicensed: boolean | undefined; //RBW_20260611 - Whether the SIM's company holds the Location Awareness licence (threaded down from the Manage SIM modal)

  public gridHasBeenClicked: boolean=false;
  public networkEvent      : NetworkEventRecordDTO | undefined;
  public networkEventForm! : UntypedFormGroup;

  constructor(
    private datePipe         : DatePipe,
    private exceptionsService: ExceptionsService,
    private formBuilder      : UntypedFormBuilder
  ) {

  }

  public ngOnInit(): void {
    try {
      this.setUpForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public ngAfterViewInit(): void {
    try {
       
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public showNetworkEvent(networkEvent: NetworkEventRecordDTO | undefined): void {
    try {
      //RBW_20260611 - The grid already loaded the full record (every detail field, including the Location Awareness data) on its initial fetch, so
      //               display it directly on expand instead of re-querying the same API. Rebuild the form first to clear the previous row's values,
      //               then populate from the passed-in record.
      this.networkEvent=undefined;

      this.setUpForm();

      this.networkEvent=networkEvent;

      this.populateFormFields(this.networkEventForm);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  get formOfNetworkEvent() {
    return this.networkEventForm.controls;
  }
    
  private setUpForm() {
    try {
      this.buildForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private buildForm() {
    try {
      this.removeFormFields(this.networkEventForm);
  
      this.networkEventForm=this.formBuilder.group({ });
              
      this.addFormFields(this.networkEventForm);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
      
  private addFormFields(formGroup: UntypedFormGroup) {
    try {
      if (formGroup==this.networkEventForm) {
        this.addFormControl(formGroup, "APN",               "", []);
        this.addFormControl(formGroup, "APNOverride",       "", []);
        this.addFormControl(formGroup, "AssignedIP",        "", []);
        this.addFormControl(formGroup, "BranchID",          "", []);
        this.addFormControl(formGroup, "CellID",            "", []);
        this.addFormControl(formGroup, "Country",           "", []);
        this.addFormControl(formGroup, "CountryFlag",       "", []);
        this.addFormControl(formGroup, "DeviceModel",       "", []);
        this.addFormControl(formGroup, "DeviceVendor",      "", []);
        this.addFormControl(formGroup, "Downlink",          "", []);
        this.addFormControl(formGroup, "EventDate",         "", []);
        this.addFormControl(formGroup, "ICCID",             "", []);
        this.addFormControl(formGroup, "id",                "", []);
        this.addFormControl(formGroup, "IMEI",              "", []);
        this.addFormControl(formGroup, "IMSI",              "", []);
        this.addFormControl(formGroup, "InputPackets",      "", []);
        this.addFormControl(formGroup, "LACID",             "", []);
        this.addFormControl(formGroup, "MCCMNC",            "", []);
        this.addFormControl(formGroup, "MSISDN",            "", []);
        this.addFormControl(formGroup, "NetworkGeneration", "", []);
        this.addFormControl(formGroup, "OutputPackets",     "", []);
        // this.addFormControl(formGroup, "Product",           "", []);
        this.addFormControl(formGroup, "RatType",           "", []);
        this.addFormControl(formGroup, "SD",                "", []);
        this.addFormControl(formGroup, "SessionTime",       "", []);
        this.addFormControl(formGroup, "Source",            "", []);
        this.addFormControl(formGroup, "Status",            "", []);
        this.addFormControl(formGroup, "SubStatus",         "", []);
        this.addFormControl(formGroup, "SubscriberIP",      "", []);
        this.addFormControl(formGroup, "Type",              "", []);
        this.addFormControl(formGroup, "Uplink",            "", []);
        this.addFormControl(formGroup, "VPLMN",             "", []);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  private addFormControl(form      : UntypedFormGroup,
                         dataField : string,
                         value     : boolean | string,
                         validators: Validators) {
    try {
      form.addControl(dataField, new FormControl(value, validators));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
      
  private removeFormFields(form: UntypedFormGroup) {
    try {
      if (form != undefined) {
        for (let control in form.controls) {
          form.removeControl(control);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
      
  private populateFormFields(formGroup: UntypedFormGroup) {
    try {
      if (formGroup==this.networkEventForm && this.networkEvent != undefined) {
        this.networkEventForm.controls["APN"].setValue(this.networkEvent.APN);
        this.networkEventForm.controls["APNOverride"].setValue(this.networkEvent.APNOverride);
        this.networkEventForm.controls["AssignedIP"].setValue(this.networkEvent.AssignedIP);
        this.networkEventForm.controls["BranchID"].setValue(this.networkEvent.BranchID);
        this.networkEventForm.controls["CellID"].setValue(this.networkEvent.CellID);
        this.networkEventForm.controls["Country"].setValue(this.networkEvent.Country);
        this.networkEventForm.controls["CountryFlag"].setValue(this.networkEvent.CountryFlag);
        this.networkEventForm.controls["DeviceModel"].setValue(this.networkEvent.DeviceModel);
        this.networkEventForm.controls["DeviceVendor"].setValue(this.networkEvent.DeviceVendor);
        this.networkEventForm.controls["Downlink"].setValue(this.networkEvent.Downlink);
        this.networkEventForm.controls["EventDate"].setValue(this.datePipe.transform((new Date(this.networkEvent.EventDate)), 'dd/MM/yyyy HH:mm:ss'));
        this.networkEventForm.controls["ICCID"].setValue(this.networkEvent.ICCID);
        this.networkEventForm.controls["id"].setValue(this.networkEvent.id);
        this.networkEventForm.controls["IMEI"].setValue(this.networkEvent.IMEI);
        this.networkEventForm.controls["IMSI"].setValue(this.networkEvent.IMSI);
        this.networkEventForm.controls["InputPackets"].setValue(this.networkEvent.InputPackets);
        this.networkEventForm.controls["LACID"].setValue(this.networkEvent.LACID);
        this.networkEventForm.controls["MCCMNC"].setValue(this.networkEvent.MCCMNC);
        this.networkEventForm.controls["MSISDN"].setValue(this.networkEvent.MSISDN);
        this.networkEventForm.controls["NetworkGeneration"].setValue(this.networkEvent.NetworkGeneration);
        this.networkEventForm.controls["OutputPackets"].setValue(this.networkEvent.OutputPackets);
        // this.networkEventForm.controls["Product"].setValue(this.networkEvent.Product);
        this.networkEventForm.controls["RatType"].setValue(this.networkEvent.RatType);
        this.networkEventForm.controls["SD"].setValue(this.networkEvent.SD);
        this.networkEventForm.controls["SessionTime"].setValue(this.networkEvent.SessionTime);
        this.networkEventForm.controls["Source"].setValue(this.networkEvent.Source);
        this.networkEventForm.controls["Status"].setValue(this.networkEvent.Status);
        this.networkEventForm.controls["SubStatus"].setValue(this.networkEvent.SubStatus);
        this.networkEventForm.controls["SubscriberIP"].setValue(this.networkEvent.SubscriberIP);
        this.networkEventForm.controls["Type"].setValue(this.networkEvent.Type);
        this.networkEventForm.controls["Uplink"].setValue(this.networkEvent.Uplink);
        this.networkEventForm.controls["VPLMN"].setValue(this.networkEvent.VPLMN);
       }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
